/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';
import { jsx as _jsx } from "react/jsx-runtime";
const commentContent = /*#__PURE__*/_jsx(SVG, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68822 16.625L5.5 17.8145L5.5 5.5L18.5 5.5L18.5 16.625L6.68822 16.625ZM7.31 18.125L19 18.125C19.5523 18.125 20 17.6773 20 17.125L20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19.5247C4 19.8173 4.16123 20.086 4.41935 20.2237C4.72711 20.3878 5.10601 20.3313 5.35252 20.0845L7.31 18.125ZM16 9.99997H8V8.49997H16V9.99997ZM8 14H13V12.5H8V14Z"
  })
});
export default commentContent;
//# sourceMappingURL=comment-content.js.map